import React from 'react';
import { Text, ProgressBar, Checkbox, DatePicker, Button } from '../../Atoms';
import { Input, AffiliationRecapMolecule, AffiliationButtonMolecule } from '../../Molecules';
import { Row, Col } from 'react-bootstrap';

function OrganismAffiliationStage3(props) {

    const renderRemboursement = (data, index, onChange) => {
        return (<Row className="organism-affiliation-stage1-row" >
            <Col lg={3} xs={12} sm={12} className="organism-affiliation-stage1-col">
                <Input
                    placeholder="Nom et prénom"
                    inputLabel="Propriétaire du compte"
                    labelClassName="organism-affiliation-stage1-input-label"
                    classNameInputContainer="organism-affiliation-stage1-input-container"
                    onChange={onChange[0]}
                    value={data.name}
                />
            </Col>
            <Col lg={5} xs={12} sm={12} className="organism-affiliation-stage1-col" >
                <Input
                    placeholder="IBAN"
                    inputLabel="IBAN"
                    labelClassName="organism-affiliation-stage1-input-label"
                    classNameInputContainer="organism-affiliation-stage1-input-container"
                    onChange={onChange[1]}
                    value={data.IBAN}
                />
            </Col>
            <Col lg={3} xs={12} sm={12} className="organism-affiliation-stage1-col">
                <Input
                    placeholder="BIC"
                    inputLabel="BIC"
                    labelClassName="organism-affiliation-stage1-input-label"
                    classNameInputContainer="organism-affiliation-stage1-input-container"
                    onChange={onChange[2]}
                    value={data.BIC}
                />
            </Col>
        </Row>)
    }
    return (
        <div className="organism-affilation-stage1-container">
            <Text text="Complétez votre affiliation" className="organism-affiliation-stage1-title" />
            <Text text="Afin de finaliser votre adhésion, merci de bien vouloir remplir les champs suivants :" className="organism-affiliation-stage1-description" />
            <Text text={`Etape ${props.stage} / 5`} className="organism-affiliation-stage1-stage" />
            <ProgressBar
                percent={`${(props.stage * 100 / 5).toString()}%`}
                height="15px"
                backgroundColor="#fff"
                backgroundColorFulFilled="#FF8AD8"
                containerClassName="organism-affiliation-stage1-progressBar"
            />
            <div >
                <div className="organism-affiliation-stage1-recap-container">
                    <AffiliationRecapMolecule />
                </div>
                <div className="organism-affiliation-form-container">
                    <Text text="Informations bancaires" className="organism-affiliation-stage1-personal-info" />
                    <Text text="Remboursements" className="organism-affiliation-stage1-remboursement organism-affiliation-stage2-remboursement" />
                    {props.remboursementData.map((element, index) => {
                        return renderRemboursement(element, index, [
                            (e) => props.inputRemboursementChange(e.target.value, { value: 'name', index: index }),
                            (e) => props.inputRemboursementChange(e.target.value, { value: 'IBAN', index: index }),
                            (e) => props.inputRemboursementChange(e.target.value, { value: 'BIC', index: index }),
                        ])
                    })}
                    <Button text="Ajouter un compte" className="organism-affiliation-stage2-button" onClick={props.addRemboursement} />
                    {props.option == 1 && <div>
                        <div className="organism-affiliation-stage2-description organism-affiliation-stage2-remboursement"><span>Prélèvements</span>(l’option sera prélevée sur votre compte bancaire)</div>
                        {props.prelevmentData.map((element, index) => {
                            return renderRemboursement(element, index, [
                                (e) => props.inputPrelevmentChange(e.target.value, { value: 'name', index: index }),
                                (e) => props.inputPrelevmentChange(e.target.value, { value: 'IBAN', index: index }),
                                (e) => props.inputPrelevmentChange(e.target.value, { value: 'BIC', index: index }),
                            ])
                        })}
                        <Button text="Ajouter un compte" className="organism-affiliation-stage2-button" onClick={props.addPrelevment} />
                    </div>}
                </div>
            </div>
            <AffiliationButtonMolecule
                confirmerClicked={props.confirmerClicked}
                goBackClicked={props.goBackClicked}
            />
        </div>
    );
}

export default OrganismAffiliationStage3;
